export const InboxLineName = 'inboxLineComponent';
